export default __webpack_public_path__ + "static/media/eye-open-dark.db08684c.svg";